import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=03f5beac&scoped=true&"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=03f5beac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f5beac",
  null
  
)

export default component.exports